import { render, staticRenderFns } from "./BlacklistDetailDrawer.vue?vue&type=template&id=0ad01b86&scoped=true"
import script from "./BlacklistDetailDrawer.vue?vue&type=script&lang=js"
export * from "./BlacklistDetailDrawer.vue?vue&type=script&lang=js"
import style0 from "./BlacklistDetailDrawer.vue?vue&type=style&index=0&id=0ad01b86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad01b86",
  null
  
)

export default component.exports